import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { UICardContent } from './uiCardContent';

import UIContentShape from './shared/proptypes';

import styles from './styles.scss';

export const UICard = (props) => {
  const { uiContent, isPlaceholder, theme, onClick, url, isCardStyle, preLoad } = props;

  const isSmallCard = theme === 'CARD_SMALL';
  const isMediumCard = theme === 'CARD_MEDIUM';
  const isWideCard = theme === 'CARD_WIDE';

  return (
    <div
      className={classnames(styles.card, {
        [styles['card-medium']]: isMediumCard,
        [styles['card-small']]: isSmallCard,
        [styles['card-wide']]: isWideCard,
        [styles['card-style']]: isCardStyle,
      })}
    >
      {Object.keys(uiContent).map(
        (contentSize) =>
          uiContent[contentSize] ? (
            <UICardContent
              {...uiContent[contentSize]}
              contentSize={contentSize}
              isSmallCard={isSmallCard}
              onClick={onClick}
              url={url}
              isPlaceholder={isPlaceholder}
              preLoad={preLoad}
              lazyLoadImage={isSmallCard}
              key={contentSize}
            />
          ) : null,
      )}
    </div>
  );
};

UICard.propTypes = {
  uiContent: PropTypes.shape({
    // default will always provide content relative and appropriate to the theme.
    default: PropTypes.shape({ ...UIContentShape }).isRequired,
    // expanded will provide more content when the theme === CARD_SMALL to show more data on Desktop.
    expanded: PropTypes.shape({ ...UIContentShape }),
  }).isRequired,
  url: PropTypes.string,
  isPlaceholder: PropTypes.bool,
  theme: PropTypes.string,
  onClick: PropTypes.func,
  isCardStyle: PropTypes.bool,
  preLoad: PropTypes.bool,
};

UICard.defaultProps = {
  isPlaceholder: false,
  theme: 'CARD_LARGE',
  url: '',
  onClick: () => {},
  isCardStyle: false,
  preLoad: false,
};

export default UICard;
